import type { StatusColor } from '@ztechapps/common.contract'
import { PurchaseOrderStatusEnum, StatusToneEnum } from '@ztechapps/common.contract'

export type PurchaseOrderStatusDetailType = {
  description: string
  sort: number
  value: PurchaseOrderStatusEnum
} & StatusColor

export type PurchaseOrderStatusType = {
  draft: PurchaseOrderStatusDetailType
  requestForQuotation: PurchaseOrderStatusDetailType
  purchaseOrder: PurchaseOrderStatusDetailType
  partiallyReceived: PurchaseOrderStatusDetailType
  received: PurchaseOrderStatusDetailType
  cancelled: PurchaseOrderStatusDetailType
}

// Each custom color is a CSS custom property declared in libs/webui/util/src/Status/StatusColor.scss; it resolves only in a browser that has loaded that stylesheet.
export const PurchaseOrderStatus: PurchaseOrderStatusType = {
  draft: {
    value: PurchaseOrderStatusEnum.Draft,
    description: 'The purchase order was still on draft.',
    sort: 1,
    tone: StatusToneEnum.Draft,
  },
  requestForQuotation: {
    value: PurchaseOrderStatusEnum.RequestForQuotation,
    description: 'The purchase order was sent to the vendor.',
    sort: 2,
    color: 'var(--status-custom-orange)',
  },
  purchaseOrder: {
    value: PurchaseOrderStatusEnum.PurchaseOrder,
    description: 'The purchase order was active.',
    sort: 3,
    color: 'var(--status-custom-blue)',
  },
  partiallyReceived: {
    value: PurchaseOrderStatusEnum.PartiallyReceived,
    description: 'The purchase order was partially received',
    sort: 4,
    color: 'var(--status-custom-violet)',
  },
  received: {
    value: PurchaseOrderStatusEnum.Received,
    description: 'The purchase order was received',
    sort: 5,
    tone: StatusToneEnum.Active,
  },
  cancelled: {
    value: PurchaseOrderStatusEnum.Cancelled,
    description: 'The purchase order was cancelled',
    sort: 6,
    tone: StatusToneEnum.Cancelled,
  },
}
